import React, { useState, useEffect } from 'react';
import './ThankYouPage.css';

// Translations — English only
const TY = {
  en: {
    checks: [
      { label: 'Verifying payment',     sub: 'Confirming transaction details' },
      { label: 'Checking stock',        sub: 'Ensuring your items are available' },
      { label: 'Preparing your order',  sub: 'Creating confirmation and invoice' },
    ],
    loadingTitle: 'Your order is being processed…',
    loadingSubtitle: 'Please wait a moment while we get everything ready.',
    canceledTitle: 'Your order has been canceled',
    canceledBody: 'An error occurred while processing your order and the system collected multiple payments. All payments will be refunded within 24–72 hours.',
    refundLabel: 'Refund ID:',
    supportBtn: 'Contact support',
  },
};

function resolveLang(lang) {
  return 'en';
}

function CheckCircle({ state }) {
  if (state === 'done') {
    return (
      <div className={`oc-check-circle done`}>
        <svg className="oc-check-icon" width="14" height="11" viewBox="0 0 14 11" fill="none">
          <path d="M1 5.5L5 9.5L13 1.5" stroke="#2d7a4f" strokeWidth="2"
            strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </div>
    );
  }
  if (state === 'failed') {
    return (
      <div className={`oc-check-circle failed`}>
        <svg className="oc-check-icon" width="12" height="12" viewBox="0 0 12 12" fill="none">
          <path d="M1.5 1.5L10.5 10.5M10.5 1.5L1.5 10.5" stroke="#dc2626" strokeWidth="2"
            strokeLinecap="round" />
        </svg>
      </div>
    );
  }
  if (state === 'active') {
    return (
      <div className="oc-check-circle active">
        <div className="oc-dot-pulse">
          <span /><span /><span />
        </div>
      </div>
    );
  }
  return <div className="oc-check-circle waiting" />;
}

function LoadingView({ checkStates, progress, t }) {
  return (
    <>
      <div className="oc-spinner-wrap">
        <div className="oc-spin-ring" />
      </div>

      <h1 className="oc-loading-title">{t.loadingTitle}</h1>
      <p className="oc-loading-subtitle">
        {t.loadingSubtitle}
      </p>

      <div className="oc-check-list">
        {t.checks.map((c, i) => (
          <div key={i} className={`oc-check-row ${checkStates[i]}`}>
            <CheckCircle state={checkStates[i]} />
            <div>
              <div className="oc-check-label">{c.label}</div>
              <div className="oc-check-sub">{c.sub}</div>
            </div>
          </div>
        ))}
      </div>

      <div className="oc-progress-track">
        <div className="oc-progress-fill" style={{ width: `${progress}%` }} />
      </div>
    </>
  );
}

function CanceledView({ t }) {
  return (
    <div className="oc-final-card">
      <div className="oc-error-circle">
        <svg width="26" height="26" viewBox="0 0 24 24" fill="none"
          stroke="#dc2626" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </div>

      <h1 className="oc-final-title">{t.canceledTitle}</h1>
      <p className="oc-final-body">
        {t.canceledBody}
      </p>

      <div className="oc-order-box">
        {t.refundLabel} <strong>pi_3T0UzMQY0wZgIIqv1A1Nmk7z</strong>
      </div>

      <a href="mailto:Contact@marshesa.com" className="oc-support-btn">
        {t.supportBtn}
      </a>
    </div>
  );
}

export default function ThankYouPage({ orderNumber = 'ORD-2025-8472', lang }) {
  const t = TY[resolveLang(lang)];
  const [checkStates, setCheckStates] = useState(['waiting', 'waiting', 'waiting']);
  const [progress, setProgress]       = useState(0);
  const [showFinal, setShowFinal]     = useState(false);

  useEffect(() => {
    const schedule = [
      [0,     () => { activate(0); setProgress(5); }],
      [3300,  () => { setProgress(20); }],
      [6600,  () => { done(0); activate(1); setProgress(35); }],
      [10000, () => { setProgress(50); }],
      [13300, () => { done(1); activate(2); setProgress(65); }],
      [16600, () => { setProgress(85); }],
      [19500, () => { done(2); setProgress(100); }],
      [20000, () => { setShowFinal(false); }],
    ];

    const timers = schedule.map(([ms, fn]) => setTimeout(fn, ms));
    return () => timers.forEach(clearTimeout);
  }, []);

  function activate(i) {
    setCheckStates(prev => prev.map((s, idx) => idx === i ? 'active' : s));
  }
  function done(i) {
    setCheckStates(prev => prev.map((s, idx) => idx === i ? 'done' : s));
  }

  return (
    <div className="oc-page">
      <div className="oc-card">
        {showFinal
          ? <CanceledView t={t} />
          : <LoadingView checkStates={checkStates} progress={progress} t={t} />
        }
      </div>
    </div>
  );
}